import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Scenario } from '@models/scenario';

// Used by Material Form validation
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-dialog-add-scenario',
  templateUrl: 'add-scenario-dialog.html',
  styleUrls: ['add-scenario-dialog.scss']
})
export class DialogAddScenarioComponent implements OnInit {
  matcher = new MyErrorStateMatcher();

  get isButtonDisabled() {
    return !this.data.form.valid || !this.data.form.dirty;
  }

  constructor(
    public dialogRef: MatDialogRef<DialogAddScenarioComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
  ngOnInit() {}

  onCreate() {
    const scenario: Scenario = Object.assign({}, this.data.form.value);
    console.log(`On Create`, { scenario });
    if (this.data.form.valid) {
      // scenario.is_stress = scenario.is_stress ? 1 : 0;
      this.data.form.reset({ is_stress: null });
      this.dialogRef.close({ scenario, result: 'added' });
    } else {
      console.log('Create - Invalid form');
    }
  }
  onCopy() {
    let scenario: Scenario = Object.assign({}, this.data.form.value);
    scenario = { ...scenario, scenario_id: this.data.scenario_id };
    console.log(`On Copy`, { scenario });
    if (this.data.form.valid) {
      // scenario.is_stress = scenario.is_stress ? 1 : 0;
      this.data.form.reset({ is_stress: null });
      const value = { scenario, result: 'copied' };
      this.dialogRef.close(value);
    } else {
      console.log('Copy - Invalid form');
    }
  }
  onCancel() {
    this.data.form.reset({ is_stress: null });
    this.dialogRef.close({ scenario: this.data.form.value, result: 'cancel' });
  }
  onUpdate() {
    let scenario: Scenario = Object.assign({}, this.data.form.value);
    scenario = { ...scenario, scenario_id: this.data.scenario_id };
    if (this.data.form.valid) {
      this.data.form.reset({ is_stress: null });
      const value = { scenario, result: 'updated' };
      this.dialogRef.close(value);
    } else {
      console.log('Update - Invalid form');
    }
  }
  // onViewAssumptions() {
  //   let scenario: Scenario = Object.assign({}, this.data.form.value);
  //   scenario = { ...scenario, scenario_id: this.data.scenario_id };
  //   const value = { scenario, result: 'assumptions' };
  //   this.data.form.reset({ is_stress: true });
  //   this.dialogRef.close(value);
  // }

  public onButtonClicked() {
    if (this.data.scenario_id) {
      if(this.data.copying) { this.onCopy(); }
      else { this.onUpdate(); }
    } 
    else {
      this.onCreate();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
